import { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { authorize, clearUser, setUser } from "../redux/ducks/user";
import { ReducersTypes } from "../redux/reducers/Models";
import IndexView from "./view";
import { setCustomer } from "@/redux/ducks/customer";
import useQuery from "@/hooks/useQuery";
import useCaptchaEnterprise from "@/hooks/useCaptchaEnterprise";
import useCaptcha from "@/hooks/useCaptcha";
import { useSingleFlag } from "@/hooks/useFlags";

export default function Index() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useQuery();
  const user = useSelector((state: ReducersTypes) => state.userReducer);
  const { isEnabled: isCaptchaMtcCaptcha } = useSingleFlag('PD_CAPTCHA_MTCAPTCHA');

  const [isVisibleMenu, setIsVisibleMenu] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isVisibleModalLogin, setIsVisibleModalLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAcceptedTerms, setIsAcceptedTerms] = useState(false);
  const [error, setError] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const captchaName = "mtcaptcha-intern";

  useCaptcha({
    setIsVerified: isCaptchaMtcCaptcha ? setIsVerified : () => {},
    captchaName
  });

  useCaptchaEnterprise({
    setIsVerified: !isCaptchaMtcCaptcha ? setIsCaptchaVerified : () => {},
    captchaName: "home-captcha",
    action: "login"
  });

  useEffect(() => {
    if (isCaptchaMtcCaptcha) {
      // @ts-expect-error
      const status = window?.mtcaptcha?.getStatus?.(captchaName);
      // @ts-expect-error
      const token = window?.mtcaptcha?.getVerifiedToken?.(captchaName);
      
      if (status?.isVerified && token) {
        console.log('Captcha já verificado ao mudar de rota');
        setIsVerified(true);
      } else {
        setIsVerified(false);
      }
    }
  }, [location.pathname, isCaptchaMtcCaptcha, captchaName]);

  const toggleMenu = () => setIsVisibleMenu(isVisibleMenu => !isVisibleMenu);
  const toggleModal = () => setIsVisibleModal(isVisibleModal => !isVisibleModal);
  const toggleModalLogin = () => setIsVisibleModalLogin(isVisibleModalLogin => !isVisibleModalLogin);
  const toggleTerms = () => setIsAcceptedTerms(isAcceptedTerms => !isAcceptedTerms);

  const goToCreateAccount = () => navigate("/register");

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
  
    const cleanPlate = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    dispatch(setUser({ [name]: cleanPlate }));
  }

  const getIsValidForm = () => {
    const isCaptchaValid = isCaptchaMtcCaptcha ? isVerified : isCaptchaVerified;
    const cleanPlate = (user?.plate as string)?.replace(/[^A-Z0-9]/g, "") || "";
    return cleanPlate.length >= 5 && isAcceptedTerms && isCaptchaValid;
  };

  const handleAuthorize = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      if (errorMessage === "timeout") setError(true);
      toggleModal();

      if (isCaptchaMtcCaptcha) {
        // @ts-expect-error
        window?.mtcaptcha?.resetUI(captchaName);
        setIsVerified(false);
      } else {
        if (typeof window !== "undefined" && (window as any).grecaptcha?.reset) {
          (window as any).grecaptcha.reset();
        }
        setIsCaptchaVerified(false);
      }
      return;
    }

    navigate("/register/avulso");
  }

  const goToDebts = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!getIsValidForm() || isLoading) return;

    setIsLoading(true);

    try {
      const cleanPlate = (user?.plate as string)?.replace(/[^A-Z0-9]/g, "") || "";
      if (isCaptchaMtcCaptcha) {
        // @ts-expect-error
        const mtcaptchaToken = window?.mtcaptcha?.getVerifiedToken?.(captchaName);
        // @ts-expect-error
        const mtcaptchaStatus = window?.mtcaptcha?.getStatus?.(captchaName);
        
        
        if (!mtcaptchaToken || !mtcaptchaStatus?.isVerified) {
          setError(true);
          toggleModal();
          setIsLoading(false);
          // @ts-expect-error
          if (window?.mtcaptcha?.resetUI) {
            // @ts-expect-error
            window.mtcaptcha.resetUI(captchaName);
          }
          setIsVerified(false);
          return;
        }

        dispatch(
          authorize({
            plate: cleanPlate,
            token: mtcaptchaToken,
            callback: handleAuthorize,
          })
        );

      } else {
        const recaptchaToken = (window as any)?.recaptchaToken;
        
        if (!recaptchaToken) {
          if ((window as any).executeRecaptcha) {
            (window as any).executeRecaptcha();
          }
          setError(true);
          toggleModal();
          setIsLoading(false);
          setIsCaptchaVerified(false);
          return;
        }

        dispatch(
          authorize({
            plate: cleanPlate,
            token: recaptchaToken,
            callback: handleAuthorize,
            recaptchaAction: !isCaptchaMtcCaptcha && (window as any).getRecaptchaAction ? (window as any).getRecaptchaAction() : undefined,
          })
        );
      }

    } catch (error) {
      console.error("Erro ao enviar formulário:", error);
      setIsLoading(false);
    }
  }

  useLayoutEffect(() => {
    dispatch(setUser({ plate: '' }));
    dispatch(setCustomer({
      register: undefined,
      forgot: undefined,
      customer: undefined,
      products: undefined,
      client: undefined,
      vehicles: undefined,
      extract: undefined,
      recharges: undefined,
      isLoadingVehicles: false,
      tickets: undefined,
      debts: undefined,
    }));
    dispatch(clearUser());
    if (params.get("auth")) {
      toggleModalLogin();
    }
    
  }, []);

  return (
    <IndexView
      toggleMenu={toggleMenu}
      isVisibleMenu={isVisibleMenu}
      user={user}
      onChange={onChange}
      goToDebts={goToDebts}
      isDisabled={!getIsValidForm()}
      isLoading={isLoading}
      error={error}
      isVisibleModal={isVisibleModal}
      toggleModal={toggleModal}
      isAcceptedTerms={isAcceptedTerms}
      toggleTerms={toggleTerms}
      isVisibleModalLogin={isVisibleModalLogin}
      toggleModalLogin={toggleModalLogin}
      goToCreateAccount={goToCreateAccount}
      isCaptchaVerified={isCaptchaVerified}
      isCaptchaMtcCaptcha={isCaptchaMtcCaptcha}
    />
  );
}
